<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M40.57 16.44l-6-6a1.5 1.5 0 00-2.12 2.12L35.89 16H9a2 2 0 00-2 2v18.5A1.5 1.5 0 008.5 38a1.5 1.5 0 001.5-1.5V19h25.88l-3.36 3.36a1.58 1.58 0 00-.16 2.11 1.51 1.51 0 001.15.53 1.53 1.53 0 001.06-.44l6-6a1.51 1.51 0 000-2.12z"/></svg>